module.exports = __webpack_public_path__ + "Metronic_fda1334c35d0f5fe2afb3afebbb6774a.2d5f15f92161454f1e3c.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/metronic/fonts/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.eot
// module id = ../../../../../src/assets/metronic/src/vendors/metronic/fonts/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.eot
// module chunks = styles